import React from 'react';

function Certificate() {
  return (
    <div className='flex justify-center items-center'>
      <img
        className="object-cover w-full h-full"  // Apply object-cover class to make the image cover the container
        src="1.jpg"
        alt="placeholder"
      />
    </div>
  );
}

export default Certificate;
